(function(){
    angular
        .module('maApp.validation')
        .directive('actualStartUnique', actualStartUnique);

    actualStartUnique.$inject = ['PlannedActionsRequest'];

    function actualStartUnique(PlannedActionsRequest){
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {

                ctrl.$asyncValidators.actualStartUnique = actualStartUniqueValidator;

                function actualStartUniqueValidator() {
                    $log.debug('pbDate link arguments:','scope', scope, 'elm', elm, 'attrs', attrs, 'ctrl', ctrl);
                    //Find the $parent with a vm property.
                    var $currentParent = scope;
                    var vm = null;
                    while('$parent' in $currentParent){
                        vm = $currentParent.$parent['vm'];
                        if(vm){
                            $currentParent = null;
                            break;
                        } else {
                            $currentParent = $currentParent.$parent;
                        }
                    }

                    if(vm && vm.plan && vm.plan.id && vm.project){
                        return PlannedActionsRequest.Actual.get(vm.plan.id, vm.project, scope.actual.action.id, scope.actual.unit.id)
                            .finally(function(response){
                                $log.debug('response from attempting to fetch an actual', response);
                                    return true;
                                });
                    } else {
                        throw "actual start uniq validator is being used on a page that does not meet the necessary requirements. scope needs these properties: vm && vm.plan && vm.plan.id && vm.project";
                    }

                }
            }
        };
    }
})();